import { Stack } from '@mantine/core';
import { CreateDirectoryStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import MultiDataInputSelector from '@/pages/Editor/components/SharedFields/DataInputSelector/MultiDataInputSelector/MultiDataInputSelector.tsx';
import OutputNameField from '@/pages/Editor/components/SharedFields/OutputNameField.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: CreateDirectoryStep;
};

export function CreateDirectoryForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      {/*<Divider />*/}
      <MultiDataInputSelector step={step} />
      <OutputNameField step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
